import React from "react";
import "./WhatWeDo.css";
import Typewriter from "typewriter-effect";
import useScrollReveal from "../hooks/useScrollReveal";

const problems = [
  {
    question: "Need to ship fast but your team can't cover the full stack?",
    answer:
      "We embed senior developers into your workflow — React, Node.js, Python, or cloud infrastructure — ready to deliver from day one.",
    cta: "Extend Your Team",
  },
  {
    question:
      "Your application needs to scale but your architecture is the bottleneck?",
    answer:
      "We re-architect for scale — serverless on AWS, containerized on Kubernetes, or hybrid multi-cloud — handling millions of requests without breaking.",
    cta: "Scale My Product",
  },
  {
    question: "Have a product idea but need an MVP in weeks, not months?",
    answer:
      "Our cloud-native frameworks and pre-built modules speed up MVP delivery by 50%. Launch fast, validate, iterate.",
    cta: "Launch My MVP",
  },
];

function WhatWeDo() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="what-we-do reveal">
      <div className="what-we-do-header">
        <h1>
          Building in the cloud is complex.
          <br />
          Your development partner shouldn't be.
        </h1>
        <div className="typewriter-wrapper">
          <Typewriter
            options={{
              strings: [
                "Cloud Architecture",
                "Full-Stack Development",
                "Mobile Applications",
                "Data Platforms",
                "DevOps & CI/CD",
              ],
              autoStart: true,
              loop: true,
              delay: 50,
              skipAddStyles: true,
            }}
          />
        </div>
      </div>
      <div className="problem-cards">
        {problems.map((p, idx) => (
          <div className={`problem-card reveal-delay-${idx + 1}`} key={idx}>
            <h3 className="problem-question">{p.question}</h3>
            <p className="problem-answer">{p.answer}</p>
            <a href="#contact" className="problem-cta">
              {p.cta} &rarr;
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WhatWeDo;
